'use strict';
module.exports = [
  '$scope',
  'keywordsService',
  '$state',
  'translateFilter',
  '$uibModal',
  'toastService',
  function ($scope, keywordsService, $state, translateFilter, $uibModal, toastService) {
    $scope.keywords = null;

    var mainConfig = global.ngDroAstralSituationRecordMainConfig;

    $scope.pagination = {
      page: 1,
      size: parseInt(mainConfig.PageSize),
      totalElements: 0,
      numberOfElements: 0,
      totalPages: 0,
    };

    $scope.displayedElements = function () {
      var a = ($scope.pagination.page - 1) * $scope.pagination.size + 1;
      var b =
        $scope.pagination.page * $scope.pagination.size > $scope.pagination.totalElements
          ? $scope.pagination.totalElements
          : $scope.pagination.page * $scope.pagination.size;
      var c = $scope.pagination.totalElements;

      return a + ' &ndash; ' + b + ' di ' + c;
    };

    function findAll() {
      keywordsService.findAllPaginated(
        {
          page: $scope.pagination.page - 1,
          size: $scope.pagination.size,
        },
        function (response) {
          $scope.keywords = response;
          $scope.pagination.totalElements = response.totalElements;
          $scope.pagination.numberOfElements = response.numberOfElements;
          $scope.pagination.totalPages = response.totalElements / response.numberOfElements;
        }
      );
    }

    findAll({
      page: $scope.pagination.page - 1,
      size: $scope.pagination.size,
    });

    $scope.pageChanged = function () {
      findAll({
        page: $scope.pagination.page - 1,
        size: $scope.pagination.size,
      });
    };

    $scope.add = function () {
      $state.go('situation-record-keyword-add');
    };

    $scope.edit = function (item) {
      $state.go('situation-record-keyword-edit', { id: item.id });
    };

    $scope.delete = function (item) {
      var dialogInst = $uibModal.open({
        template: require('../../modal/modalQuest.html'),
        controller: 'modalQuestCtrl',
        size: 'md',
        resolve: {
          params: function () {
            return {
              headerMessage: translateFilter('AstralSituationRecord.attention'),
              bodyMessage: 'Sei sicuro di voler eliminare ' + item.comment.comment + '?',
              showCancelButton: true,
              showYesButton: true,
              cancelButtonText: translateFilter('AstralSituationRecord.cancel'),
              yesButtonText: translateFilter('AstralSituationRecord.yes'),
            };
          },
        },
      });

      dialogInst.result.then(
        function () {
          keywordsService.delete(
            { id: item.id },
            function () {
              toastService.createSuccessToast('Etichetta eliminata con successo');
              $scope.pageChanged();
            },
            function (error) {
              toastService.createErrorToast("Errore durante l'eliminazione dell'etichetta");
              $scope.error = error.data;
            }
          );
        },
        function () {}
      );
    };
  },
];



//////////////////
// WEBPACK FOOTER
// ./src/modules/ngDro-AstralSituationRecord/components/keyword/keywordList/keywordListCtrl.js
// module id = 247
// module chunks = 0